import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ImageDialogData {
    quoteId: string;
    imageUrl: string;
}

@Component({
    selector: 'app-image-dialog',
    templateUrl: './image-dialog.component.html',
    styleUrls: ['./image-dialog.component.scss'],
    standalone: false
})
export class ImageDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ImageDialogData) {}
}
